import { useMemo } from 'react';
import {
  RegisterAndSubscribeToMachineBindingDocument,
  RegisterAndSubscribeToMachineBindingSubscriptionResult,
  RegisterAndSubscribeToMachineBindingSubscriptionVariables,
} from '../../graphql/generated';
import { useApolloSharedSubscription } from '../../subscription/apollo-subscription.manager';
import {
  RobotOperationBindingResult,
  isExecuteFlowStatusFeedbackResult,
} from './robot-operation.binding';

export const useRobotOperationMonitorBinding = (
  machineId: string,
  options?: { skip?: boolean }
): RobotOperationBindingResult | undefined => {
  const variables: RegisterAndSubscribeToMachineBindingSubscriptionVariables = {
    input: {
      machineId,
      binding: {
        namespace: 'machine',
        type: 'robotOperationMonitor',
      },
    },
  };

  const { data } =
    useApolloSharedSubscription<RegisterAndSubscribeToMachineBindingSubscriptionResult>(
      {
        query: RegisterAndSubscribeToMachineBindingDocument,
        variables,
        subscriptionName: `binding-machine-robotOperationMonitor-${machineId}`,
        skip: options?.skip,
      }
    );

  return data?.registerAndSubscribeToMachineBindingResult?.data;
};

/**
 * Returns the current execution index of the robot operation flow.
 */
export const useRobotOperationFlowExecutionIndex = (
  machineId: string,
  options?: { skip?: boolean }
): number | undefined => {
  const result = useRobotOperationMonitorBinding(machineId, options);

  return useMemo(() => {
    if (!result) {
      return;
    }

    if (!isExecuteFlowStatusFeedbackResult(result)) {
      return;
    }

    return result.feedbackData.executionIndex;
  }, [result]);
};
